import React, { ChangeEvent } from "react";
import { useLabels } from "../../hooks/useLabels";
import { Checkbox } from "../checkbox";
import { labels } from "./labels";

export function DontAskAgainCheckbox({
	sessionKey,
	label = labels.dontAskAgain,
}: {
	sessionKey: string;
	label?: eXpress.creator.LabelRequest;
}) {
	const [[dontAskAgainLabel], areLabelsLoading] = useLabels([label]);

	const toggle = (remember = true) => {
		if (remember) {
			// "true" is just a placeholder since we need to pass some data to the actual sessionStorage item.
			sessionStorage.setItem(sessionKey, "true");
		} else {
			sessionStorage.removeItem(sessionKey);
		}
	};

	return areLabelsLoading ? null : (
		<Checkbox
			className="refill-dialog__checkbox"
			id={sessionKey}
			onChange={(e: ChangeEvent<HTMLInputElement>) => toggle(e.currentTarget.checked)}
			label={dontAskAgainLabel}
			checked={false}
		/>
	);
}
